import * as React from 'react';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Link from '@mui/material/Link';
import AddIcon from '@mui/icons-material/Add';

export default function AddButton({ name,path, sx }) {
  return (
    <Stack direction="row" spacing={2}>
      <Button variant="contained" color="secondary" component={Link} startIcon={<AddIcon />} href={`/${path}/new`} sx={{ ...sx }}>
        {name}
      </Button>
    </Stack>
  );
}
